import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class TimeOutPopupService {
    private timeoutStatus = new BehaviorSubject<boolean>(false);
    public obvPopup: Observable<boolean> = this.timeoutStatus.asObservable();

    constructor() {
    }

    setTimeoutStatus(value: boolean) {
        this.timeoutStatus.next(value);
    }

    getTimeoutStatus(): Observable<boolean> {
        return this.obvPopup;
    }
}